export const transactionTypes: string[] = ["correction", "bonus"];
